/** Light and dark theme CSS custom property definitions */
export const lightTokens = `
  --sw-bg: #FFFFFF;
  --sw-text-primary: #1A1A2E;
  --sw-text-secondary: #4A4A68;
  --sw-accent: #C8A800;
  --sw-accent-hover: #A08600;
  --sw-button-bg: #F5C518;
  --sw-button-text: #1A1A2E;
  --sw-button-hover-bg: #E0B400;
  --sw-border: #E8E8EC;
  --sw-shadow: 0 1px 4px rgba(0,0,0,0.04), 0 2px 8px rgba(0,0,0,0.04);
  --sw-focus-ring: #4D65FF;
  --sw-hover-tint: rgba(200,168,0,0.08);
  --sw-active-tint: rgba(200,168,0,0.16);
  --sw-logo-bg: transparent;
`;

export const darkTokens = `
  --sw-bg: #1A1A2E;
  --sw-text-primary: #F0F0F5;
  --sw-text-secondary: #B0B0C8;
  --sw-accent: #F5C518;
  --sw-accent-hover: #FFD54F;
  --sw-button-bg: #F5C518;
  --sw-button-text: #1A1A2E;
  --sw-button-hover-bg: #FFD54F;
  --sw-border: #2E2E48;
  --sw-shadow: 0 1px 4px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.12);
  --sw-focus-ring: #4D65FF;
  --sw-hover-tint: rgba(245,197,24,0.10);
  --sw-active-tint: rgba(245,197,24,0.18);
  --sw-logo-bg: rgba(255,255,255,0.9);
`;
